import { render } from "./ImagegalleryView.vue?vue&type=template&id=904de214"
import script from "./ImagegalleryView.vue?vue&type=script&lang=js"
export * from "./ImagegalleryView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__